import { Model } from ".";

export default class DriverReport extends Model {
	get singularNoun() {
		return "driver report";
	}

	resource() {
		return "yard/reports/drivers";
	}
}
